const param = [
  {'id': 1, 'name': '保险公司', 'code': '1', 'value': '1', 'type': 0},
  {'id': 2, 'name': '车辆颜色', 'code': '2', 'value': '2', 'type': 0},
  {'id': 3, 'name': '从事行业', 'code': '3', 'value': '3', 'type': 0},
  {'id': 4, 'name': '申请附件', 'code': '4', 'value': '4', 'type': 0},
  {'id': 5, 'name': '贷前附件', 'code': '5', 'value': '5', 'type': 0},
  {'id': 6, 'name': '贷后附件', 'code': '6', 'value': '6', 'type': 0},
  {'id': 7, 'name': '工作单位规模', 'code': '7', 'value': '7', 'type': 0},
  {'id': 8, 'name': '工作单位性质', 'code': '8', 'value': '8', 'type': 0},
  {'id': 9, 'name': '工作年限', 'code': '9', 'value': '9', 'type': 0},
  {'id': 10, 'name': '还款方式', 'code': '10', 'value': '10', 'type': 0},
  {'id': 11, 'name': '还款期限', 'code': '11', 'value': '11', 'type': 0},
  {'id': 12, 'name': '婚姻状况', 'code': '12', 'value': '12', 'type': 0},
  {'id': 13, 'name': '收入来源', 'code': '13', 'value': '13', 'type': 0},
  {'id': 14, 'name': '现居住时间', 'code': '14', 'value': '14', 'type': 0},
  {'id': 15, 'name': '销售区域', 'code': '15', 'value': '15', 'type': 0},
  {'id': 16, 'name': '学历', 'code': '16', 'value': '16', 'type': 0},
  {'id': 17, 'name': '与申请人关系', 'code': '17', 'value': '17', 'type': 0},
  {'id': 18, 'name': '与驾驶员关系', 'code': '18', 'value': '18', 'type': 0},
  {'id': 19, 'name': '与紧急联系人关系', 'code': '19', 'value': '19', 'type': 0},
  {'id': 20, 'name': '证件类别', 'code': '20', 'value': '20', 'type': 0},
  {'id': 21, 'name': '职位', 'code': '21', 'value': '21', 'type': 0},
  {'id': 22, 'name': '住房所有权', 'code': '22', 'value': '22', 'type': 0},
  {'id': 23, 'name': '贷款产品', 'code': '23', 'value': '23', 'type': 0},
  {'id': 24, 'name': '车辆品牌', 'code': '24', 'value': '24', 'type': 0},
  {'id': 25, 'name': '拒绝申请类型', 'code': '25', 'value': '25', 'type': 0},
  {'id': 27, 'name': '放款附件', 'code': '27', 'value': '27', 'type': 0},
  {'id': 415, 'name': 'GPS安装图', 'code': 'gpsfj', 'value': '29', 'type': 0},
  {'id': 427, 'name': '车类', 'code': 'chelei', 'value': '26', 'type': 0},
  {'id': 451, 'name': '账务系数', 'code': 'ewjkxs', 'value': '30', 'type': 0},
  {'id': 462, 'name': '借款合同模板', 'code': 'pact', 'value': '462', 'type': 0},
  {'id': 463, 'name': '抵押合同模板', 'code': 'guaranty', 'value': '463', 'type': 0},
  {'id': 480, 'name': '延保费套餐', 'code': 'ybftc', 'value': '480', 'type': 0},
  {'id': 485, 'name': '融手续费率', 'code': 'rxsfl', 'value': '485', 'type': 0},
  {'id': 499, 'name': '客户还款鉴权单标识', 'code': 'khhkjqbs', 'value': '499', 'type': 0},
  {'id': 503, 'name': '抵押渠道', 'code': 'dyqd', 'value': '503', 'type': 0},
  {'id': 516, 'name': '贷后资料情况', 'code': 'dhzilqk', 'value': '516', 'type': 0},
  {'id': 539, 'name': '利率档位', 'code': 'lldw', 'value': '31', 'type': 0},
  {'id': 543, 'name': '账户管理费率阈值', 'code': 'zhglfyz', 'value': '32', 'type': 0},
  {'id': 545, 'name': '总售比阈值', 'code': 'zsb', 'value': '33', 'type': 0},
  {'id': 554, 'name': '通过类型', 'code': 'passtype', 'value': '34', 'type': 0},
  {'id': 559, 'name': '取消类型', 'code': 'canceltype', 'value': '35', 'type': 0},
  {'id': 563, 'name': '放款审核资料', 'code': 'loanfile', 'value': '36', 'type': 0},
  {'id': 10000, 'name': '参数类型', 'code': '0', 'value': '0', 'type': 0},
  {'id': 10008, 'name': 'gps档位', 'code': 'gps', 'value': '37', 'type': 0},
  {'id': 10010, 'name': '收入材料', 'code': 'srcl', 'value': '297', 'type': 0},
  {'id': 10012, 'name': '二手车材料', 'code': 'esccl', 'value': '301', 'type': 0},
  {'id': 10014, 'name': '其他', 'code': 'qt', 'value': '302', 'type': 0},
  {'id': 10016, 'name': '征信承诺授权书', 'code': 'zxcrsqs', 'value': '357', 'type': 0},
  {'id': 10018, 'name': '保险费试算截屏', 'code': 'bxfssjp', 'value': '420', 'type': 0},
  {'id': 10020, 'name': '贷前资料', 'code': 'dq', 'value': '315', 'type': 0},
  {'id': 10022, 'name': '贷前资料(补件)', 'code': 'bj', 'value': '350', 'type': 0},
  {'id': 10025, 'name': '贷后资料', 'code': 'dhzl', 'value': '351', 'type': 0},
  {'id': 10028, 'name': '其他', 'code': 'dhqt', 'value': '356', 'type': 0},
  {'id': 10030, 'name': '绿本资料', 'code': 'lbzl', 'value': '38', 'type': 0},
  {'id': 10032, 'name': '准驾车型', 'code': 'zjcx', 'value': '40', 'type': 0},
  {'id': 10055, 'name': '驾驶证', 'code': 'sjdcs', 'value': '10054', 'type': 0},
  {'id': 10096, 'name': '卡类型', 'code': 'klx', 'value': '41', 'type': 0},
  {'id': 10099, 'name': '现单位工作年限', 'code': 'gznx', 'value': '42', 'type': 0},
  {'id': 10106, 'name': '是否自带征信', 'code': 'sfzdzx', 'value': '43', 'type': 0},
  {'id': 10111, 'name': '评估公司', 'code': 'pggs', 'value': '44', 'type': 0},
  {'id': 10132, 'name': 'GPS供应商', 'code': 'gpsdealer', 'value': '49', 'type': 0},
  {'id': 10148, 'name': 'GPS安装方式', 'code': 'gpsazfs', 'value': '45', 'type': 0},
  {'id': 10153, 'name': '延保费套餐', 'code': 'ybftc', 'value': '50', 'type': 0},
  {'id': 10159, 'name': 'GPS属性', 'code': 'gpspro', 'value': '55', 'type': 0},
  {'id': 10163, 'name': '浦发信用卡产品', 'code': 'code', 'value': '53', 'type': 0},
  {'id': 10164, 'name': '浦发一级分行城市代码', 'code': 'fh', 'value': '54', 'type': 0},
  {'id': 10215, 'name': '分流单量限制', 'code': 'yyfl_limit', 'value': '10', 'type': 0},
  {'id': 10245, 'name': '主贷人扫描件类型', 'code': 'scan_type', 'value': '58', 'type': 0},
  {'id': 10250, 'name': '担保人贷后资料原件', 'code': 'dbdhzlyj', 'value': '57', 'type': 0},
  {'id': 10253, 'name': '贷后资料原件', 'code': 'dhzlyj', 'value': '56', 'type': 0},
  {'id': 10266, 'name': '审批组', 'code': 'appGroup', 'value': '59', 'type': 0},
  {'id': 10316, 'name': '工作流', 'code': 'workflow', 'value': '60', 'type': 0},
  {'id': 10381, 'name': '担保情况', 'code': 'isdb', 'value': '62', 'type': 0},
  {'id': 10386, 'name': '户口性质', 'code': 'hkxz', 'value': '61', 'type': 0},
  {'id': 10572, 'name': '续保押金', 'code': 'xbyj', 'value': '64', 'type': 0},
  {'id': 10573, 'name': '人身保险', 'code': 'rsbx', 'value': '63', 'type': 0},
  {'id': 10576, 'name': '中国人民人寿保险股份有限公司', 'code': 'zgrmrsbxgf', 'value': '407', 'type': 1}, // todo 原 value 1 ，需校验
  {'id': 470, 'name': '白色', 'code': 'clys', 'value': '其他', 'type': 2},
  {'id': 471, 'name': '黑色', 'code': 'clys', 'value': '香槟色', 'type': 2},
  {'id': 472, 'name': '红色', 'code': 'clys', 'value': '灰色', 'type': 2},
  {'id': 473, 'name': '绿色', 'code': 'clys', 'value': '橙色', 'type': 2},
  {'id': 474, 'name': '黄色', 'code': 'clys', 'value': '紫色', 'type': 2},
  {'id': 475, 'name': '蓝色', 'code': 'clys', 'value': '蓝色', 'type': 2},
  {'id': 476, 'name': '紫色', 'code': 'clys', 'value': '黄色', 'type': 2},
  {'id': 477, 'name': '橙色', 'code': 'clys', 'value': '绿色', 'type': 2},
  {'id': 479, 'name': '灰色', 'code': 'clys', 'value': '红色', 'type': 2},
  {'id': 484, 'name': '香槟色', 'code': 'clys', 'value': '黑色', 'type': 2},
  {'id': 497, 'name': '其他', 'code': 'clys', 'value': '白色', 'type': 2},
  {'id': 232, 'name': '一般制造业', 'code': 'ybzzy', 'value': '一般制造业', 'type': 3},
  {'id': 233, 'name': '电子/互联网/通讯', 'code': 'dzhlwtx', 'value': '电子/互联网/通讯', 'type': 3},
  {'id': 234, 'name': '能源', 'code': 'ny', 'value': '能源', 'type': 3},
  {'id': 235, 'name': '规划/建筑/建材', 'code': 'ghjzzs', 'value': '规划/建筑/建材', 'type': 3},
  {'id': 236, 'name': '公务员/事业编制', 'code': 'gwysybz', 'value': '公务员/事业编制', 'type': 3},
  {'id': 237, 'name': '新闻/广告/传媒', 'code': 'xwggcm', 'value': '新闻/广告/传媒', 'type': 3},
  {'id': 238, 'name': '金融/经济', 'code': 'jrjj', 'value': '金融/经济', 'type': 3},
  {'id': 239, 'name': '酒店/餐饮', 'code': 'jdcy', 'value': '酒店/餐饮', 'type': 3},
  {'id': 240, 'name': '房地产/物业管理', 'code': 'fdcwygl', 'value': '房地产/物业管理', 'type': 3},
  {'id': 241, 'name': '物流/交通运输', 'code': 'wljtys', 'value': '物流/交通运输', 'type': 3},
  {'id': 242, 'name': '化工/生物', 'code': 'hgsw', 'value': '化工/生物', 'type': 3},
  {'id': 243, 'name': '医疗卫生/护理/保健', 'code': 'ylwshlbj', 'value': '医疗卫生/护理/保健', 'type': 3},
  {'id': 244, 'name': '法律', 'code': 'fl', 'value': '法律', 'type': 3},
  {'id': 245, 'name': '文化/教育/体育类/艺术', 'code': 'whjytyys', 'value': '文化/教育/体育类/艺术', 'type': 3},
  {'id': 246, 'name': '农业/林业/养殖', 'code': 'nylyyz', 'value': '农业/林业/养殖', 'type': 3},
  {'id': 297, 'name': '收入材料', 'code': 'srcl', 'value': '收入材料', 'type': 4},
  {'id': 301, 'name': '二手车材料', 'code': 'ersccl', 'value': '二手车材料', 'type': 4},
  {'id': 302, 'name': '其他', 'code': 'scfjqt', 'value': '其他', 'type': 4},
  {'id': 357, 'name': '征信承诺授权书', 'code': 'zxcnsqs', 'value': '征信承诺授权书', 'type': 4},
  {'id': 420, 'name': '保险费试算截屏', 'code': 'bxfssjp', 'value': '保险费试算截屏', 'type': 4},
  {'id': 10054, 'name': '驾驶证', 'code': 'jsz', 'value': '驾驶证', 'type': 4},
  {'id': 315, 'name': '贷前资料', 'code': 'dq', 'value': '贷前资料', 'type': 5},
  {'id': 350, 'name': '贷前资料(补件)', 'code': 'bj', 'value': '贷前资料(补件)', 'type': 5},
  {'id': 351, 'name': '贷后资料', 'code': 'dazl', 'value': '贷后资料', 'type': 6},
  {'id': 356, 'name': '其他', 'code': 'qt', 'value': '其他', 'type': 6},
  {'id': 278, 'name': '1-10', 'code': 'shiren', 'value': '10', 'type': 7},
  {'id': 279, 'name': '11-50', 'code': 'wushir', 'value': '50', 'type': 7},
  {'id': 409, 'name': '51-100', 'code': 'yibairen', 'value': '100', 'type': 7},
  {'id': 410, 'name': '101-500', 'code': 'wubairen', 'value': '500', 'type': 7},
  {'id': 411, 'name': '500以上', 'code': 'wubairenyi', 'value': '501', 'type': 7},
  {'id': 270, 'name': '政府机构', 'code': 'zfjg', 'value': '政府机构', 'type': 8},
  {'id': 271, 'name': '事业单位', 'code': 'sydw', 'value': '事业单位', 'type': 8},
  {'id': 272, 'name': '国有企业', 'code': 'gyqy', 'value': '国有企业', 'type': 8},
  {'id': 273, 'name': '金融机构', 'code': 'jrjg', 'value': '金融机构', 'type': 8},
  {'id': 274, 'name': '三资企业', 'code': 'szqy', 'value': '三资企业', 'type': 8},
  {'id': 275, 'name': '私营企业', 'code': 'syqy', 'value': '私营企业', 'type': 8},
  {'id': 276, 'name': '上市公司', 'code': 'ssgs', 'value': '上市公司', 'type': 8},
  {'id': 277, 'name': '其他', 'code': 'qt', 'value': '其他', 'type': 8},
  {'id': 316, 'name': '等额本息', 'code': 'debx', 'value': '等额本息', 'type': 10},
  {'id': 317, 'name': '等额本金', 'code': 'debj', 'value': '等额本金', 'type': 10},
  {'id': 285, 'name': '6个月', 'code': 'hkqx6', 'value': '6', 'type': 11},
  {'id': 286, 'name': '12个月', 'code': 'hkqx12', 'value': '12', 'type': 11},
  {'id': 287, 'name': '18个月', 'code': 'hkqx18', 'value': '18', 'type': 11},
  {'id': 288, 'name': '24个月', 'code': 'hkqx24', 'value': '24', 'type': 11},
  {'id': 289, 'name': '30个月', 'code': 'hkqx30', 'value': '30', 'type': 11},
  {'id': 290, 'name': '36个月', 'code': 'hkqx36', 'value': '36', 'type': 11},
  {'id': 331, 'name': '已婚', 'code': 'yh', 'value': '1', 'type': 12},
  {'id': 332, 'name': '未婚', 'code': 'wh', 'value': '0', 'type': 12},
  {'id': 333, 'name': '离异', 'code': 'ly', 'value': '2', 'type': 12},
  {'id': 334, 'name': '丧偶', 'code': 'so', 'value': '3', 'type': 12},
  {'id': 258, 'name': '工资', 'code': 'gz', 'value': '工资', 'type': 13},
  {'id': 259, 'name': '分红', 'code': 'fh', 'value': '分红', 'type': 13},
  {'id': 260, 'name': '自营收入', 'code': 'zysr', 'value': '自营收入', 'type': 13},
  {'id': 261, 'name': '租金', 'code': 'zj', 'value': '租金', 'type': 13},
  {'id': 262, 'name': '其他', 'code': 'qt', 'value': '其他', 'type': 13},
  {'id': 247, 'name': '1', 'code': 'jzsj1', 'value': '1', 'type': 14},
  {'id': 248, 'name': '2', 'code': 'jzsj2', 'value': '2', 'type': 14},
  {'id': 249, 'name': '3', 'code': 'jzsj3', 'value': '3', 'type': 14},
  {'id': 250, 'name': '4', 'code': 'jzsj4', 'value': '4', 'type': 14},
  {'id': 251, 'name': '5年以上', 'code': 'jzsj5', 'value': '5', 'type': 14},
  {'id': 318, 'name': '华东1区', 'code': 'ydq', 'value': '华东1区', 'type': 15},
  {'id': 319, 'name': '华东2区', 'code': 'edq', 'value': '华东2区', 'type': 15},
  {'id': 320, 'name': '华南区', 'code': 'sdq', 'value': '华南区', 'type': 15},
  {'id': 321, 'name': '西南区', 'code': 'sidq', 'value': '西南区', 'type': 15},
  {'id': 322, 'name': '西北区', 'code': 'wdq', 'value': '西北区', 'type': 15},
  {'id': 323, 'name': '东北区', 'code': 'ldq', 'value': '东北区', 'type': 15},
  {'id': 561, 'name': '华北区', 'code': 'hbdq', 'value': '华北区', 'type': 15},
  {'id': 562, 'name': '华东区', 'code': 'hddq', 'value': '华东区', 'type': 15},
  {'id': 335, 'name': '本科', 'code': 'bk', 'value': '1', 'type': 16},
  {'id': 336, 'name': '大专', 'code': 'zd', 'value': '0', 'type': 16},
  {'id': 337, 'name': '硕士', 'code': 'ss', 'value': '2', 'type': 16},
  {'id': 339, 'name': '其他', 'code': 'qt', 'value': '3', 'type': 16},
  {'id': 340, 'name': '博士', 'code': 'bs', 'value': '4', 'type': 16},
  {'id': 341, 'name': '高中', 'code': 'gz', 'value': '5', 'type': 16},
  {'id': 342, 'name': '小学', 'code': 'xx', 'value': '6', 'type': 16},
  {'id': 343, 'name': '初中', 'code': 'cz', 'value': '7', 'type': 16},
  {'id': 344, 'name': '中专', 'code': 'zz', 'value': '8', 'type': 16},
  {'id': 281, 'name': '朋友', 'code': 'py', 'value': '02', 'type': 17},
  {'id': 413, 'name': '父母/岳父母', 'code': 'ysqrgx1', 'value': '03', 'type': 17},
  {'id': 414, 'name': '其他亲属关系', 'code': 'qq', 'value': '04', 'type': 17},
  {'id': 418, 'name': '男女朋友', 'code': 'fq', 'value': '01', 'type': 17},
  {'id': 419, 'name': '子女/婿媳', 'code': 'zl', 'value': '05', 'type': 17},
  {'id': 422, 'name': '同事', 'code': 'ysqrgx_yg', 'value': '06', 'type': 17},
  {'id': 10433, 'name': '法人/股东/合伙人', 'code': 'frgdhhr', 'value': '07', 'type': 17},
  {'id': 263, 'name': '本人', 'code': 'br', 'value': '01', 'type': 18},
  {'id': 264, 'name': '配偶', 'code': 'po', 'value': '02', 'type': 18},
  {'id': 266, 'name': '直系家属(是担保人)', 'code': 'dbr', 'value': '04', 'type': 18},
  {'id': 267, 'name': '父母', 'code': 'fm', 'value': '父母', 'type': 19},
  {'id': 268, 'name': '其他亲属', 'code': 'qs', 'value': '其他亲属', 'type': 19},
  {'id': 269, 'name': '朋友', 'code': 'py', 'value': '朋友', 'type': 19},
  {'id': 10567, 'name': '兄弟/姐妹', 'code': 'xdjm', 'value': '兄弟/姐妹', 'type': 19},
  {'id': 10568, 'name': '子女', 'code': 'zn', 'value': '子女', 'type': 19},
  {'id': 230, 'name': '居民身份证', 'code': 'jmsfz', 'value': '15', 'type': 20},
  {'id': 231, 'name': '护照', 'code': 'hz', 'value': '20', 'type': 20},
  {'id': 426, 'name': '军官证/士兵证', 'code': 'jgz', 'value': '17', 'type': 20},
  {'id': 252, 'name': '员工', 'code': 'yg', 'value': '员工', 'type': 21},
  {'id': 253, 'name': '企业所有者', 'code': 'qysyz', 'value': '企业所有者', 'type': 21},
  {'id': 254, 'name': '企业管理人员', 'code': 'qyglry', 'value': '企业管理人员', 'type': 21},
  {'id': 255, 'name': '个体户', 'code': 'gth', 'value': '个体户', 'type': 21},
  {'id': 256, 'name': '自营业主', 'code': 'zyyz', 'value': '自营业主', 'type': 21},
  {'id': 257, 'name': '事业单位人员', 'code': 'sydwry', 'value': '事业单位人员', 'type': 21},
  {'id': 224, 'name': '自有一套-无贷款', 'code': 'zyytwdk', 'value': '自有一套-无贷款', 'type': 22},
  {'id': 225, 'name': '自有一套-有贷款', 'code': 'zyytydk', 'value': '自有一套-有贷款', 'type': 22},
  {'id': 226, 'name': '租房-老家有房', 'code': 'zfljyf', 'value': '租房-老家有房', 'type': 22},
  {'id': 227, 'name': '父母房产', 'code': 'fmfc', 'value': '父母房产', 'type': 22},
  {'id': 228, 'name': '自有一套以上-无贷款', 'code': 'zyytyswdk', 'value': '自有一套以上-无贷款', 'type': 22},
  {'id': 229, 'name': '自有一套以上-有贷款', 'code': 'zyytysydk', 'value': '自有一套以上-有贷款', 'type': 22},
  {'id': 283, 'name': '二手车-456随信贷', 'code': 'shxd', 'value': '2', 'type': 23},
  {'id': 284, 'name': '二手车-369随心贷', 'code': 'sxid', 'value': '1', 'type': 23},
  {'id': 365, 'name': 'LCV-农户贷', 'code': 'lcv', 'value': '4', 'type': 23},
  {'id': 366, 'name': '新车-随易贷', 'code': 'syd', 'value': '3', 'type': 23},
  {'id': 412, 'name': '新车-标准产品', 'code': 'ncbzcp', 'value': '6', 'type': 23},
  {'id': 421, 'name': '有心有利产品—LCV专享', 'code': 'yxyl_lcv', 'value': '7', 'type': 23},
  {'id': 423, 'name': '一本万金(力帆专享)', 'code': 'ybwj', 'value': '8', 'type': 23},
  {'id': 424, 'name': '一本万利(力帆专享)', 'code': 'ybwl', 'value': '9', 'type': 23},
  {'id': 439, 'name': '员工优惠利率', 'code': 'ygll', 'value': '10', 'type': 23},
  {'id': 442, 'name': '新时贷A(369融保险)', 'code': 'xsdA', 'value': '11', 'type': 23},
  {'id': 443, 'name': '新时贷B(456融保险)', 'code': 'xsdB', 'value': '12', 'type': 23},
  {'id': 444, 'name': '新时贷C融(二手车两证一卡融保险)', 'code': 'xsdC', 'value': '13', 'type': 23},
  {'id': 445, 'name': '新时贷D(新车融保险)', 'code': 'xsdD', 'value': '14', 'type': 23},
  {'id': 446, 'name': '新时贷E融(新车两证一卡融保险)', 'code': 'xsdE', 'value': '15', 'type': 23},
  {'id': 449, 'name': '新时贷C(二手车两证一卡)', 'code': 'xsdC2', 'value': '18', 'type': 23},
  {'id': 450, 'name': '新时贷E(新车两证一卡)', 'code': 'xsdE2', 'value': '19', 'type': 23},
  {'id': 453, 'name': '长安无忧贷', 'code': 'cawyd', 'value': '20', 'type': 23},
  {'id': 329, 'name': '资料有误', 'code': '01', 'value': '资料有误', 'type': 25},
  {'id': 435, 'name': '拒绝-欺诈性', 'code': '07', 'value': '拒绝-欺诈性', 'type': 25},
  {'id': 436, 'name': '拒绝-信用类', 'code': '08', 'value': '拒绝-信用类', 'type': 25},
  {'id': 437, 'name': '拒绝-黑名单', 'code': '09', 'value': '拒绝-黑名单', 'type': 25},
  {'id': 438, 'name': '拒绝-其他', 'code': '10', 'value': '拒绝-其他', 'type': 25},
  {'id': 428, 'name': '乘用车', 'code': 'cyc', 'value': '0', 'type': 26},
  {'id': 429, 'name': 'LCV', 'code': 'LCV', 'value': '1', 'type': 26},
  {'id': 345, 'name': '贷前审批附件', 'code': 'dq', 'value': '贷前审批附件', 'type': 28},
  {'id': 346, 'name': 'PBOC岗附件(征信报告)', 'code': 'pboc', 'value': 'PBOC岗附件(征信报告)', 'type': 28},
  {'id': 347, 'name': '信贷审批岗附件(国政通)', 'code': 'xd', 'value': '信贷审批岗附件(国政通)', 'type': 28},
  {'id': 348, 'name': '贷后审批附件', 'code': 'dh', 'value': '贷后审批附件', 'type': 28},
  {'id': 352, 'name': '其他', 'code': 'qt', 'value': '其他', 'type': 28},
  {'id': 359, 'name': '信贷审批岗附件(二手车评估)', 'code': 'xdspfjescp', 'value': '信贷审批岗附件(二手车评估)', 'type': 28},
  {'id': 360, 'name': '信贷审批岗附件(评分)', 'code': 'xdspfjcj', 'value': '信贷审批岗附件(评分)', 'type': 28},
  {'id': 361, 'name': '信贷审批岗附件(补充材料)', 'code': 'xdspfjbccl', 'value': '信贷审批岗附件(补充材料)', 'type': 28},
  {'id': 362, 'name': '贷前资料岗附件(补充)', 'code': 'dqzlg', 'value': '贷前资料岗附件(补充)', 'type': 28},
  {'id': 363, 'name': '贷前资料岗附件(其他)', 'code': 'dqzlgqt', 'value': '贷前资料岗附件(其他)', 'type': 28},
  {'id': 458, 'name': '放款附件', 'code': 'xtts_fkfj', 'value': '放款附件', 'type': 28},
  {'id': 10423, 'name': '新车发票', 'code': '', 'value': 'cat_invoice', 'type': 28},
  {'id': 10424, 'name': '购置税票或者完税凭证', 'code': '', 'value': 'purchase_tax_invoice', 'type': 28},
  {'id': 10425, 'name': '交强险保单或者发票、商业险保单或者发票', 'code': '', 'value': 'traffic_compulsory_insurance', 'type': 28},
  {'id': 10426, 'name': '车辆登记证上牌页、抵押页', 'code': '', 'value': 'car_reg_cert', 'type': 28},
  {'id': 416, 'name': '平安六吉GPS安装图', 'code': 'palj', 'value': '平安六吉GPS安装图', 'type': 29},
  {'id': 417, 'name': '赛格车圣GPS安装图', 'code': 'sgcs', 'value': '赛格车圣GPS安装图', 'type': 29},
  {'id': 454, 'name': '铜板街额外借款系数', 'code': 'ewjkxs-2', 'value': '0.04', 'type': 30},
  {'id': 459, 'name': ' 网额外借款系数', 'code': 'ewjkxs-3', 'value': '0', 'type': 30},
  {'id': 10223, 'name': '浦发等额还款利率', 'code': 'pfdehk', 'value': '12', 'type': 31},
  {'id': 544, 'name': '账户管理费率阈值0.05', 'code': 'zhglfyz1', 'value': '0.05', 'type': 32},
  {'id': 546, 'name': '总售比', 'code': 'zsbyz1', 'value': '0.92', 'type': 33},
  {'id': 555, 'name': '全额批复', 'code': 'fullpass', 'value': '全额批复', 'type': 34},
  {'id': 556, 'name': '有条件批复', 'code': 'condition', 'value': '有条件批复', 'type': 34},
  {'id': 557, 'name': '复议通过', 'code': 'delear', 'value': '复议通过', 'type': 34},
  {'id': 558, 'name': '特批', 'code': 'tp', 'value': '特批', 'type': 34},
  {'id': 431, 'name': '取消-客户主动取消', 'code': '03', 'value': '取消-客户主动取消', 'type': 35},
  {'id': 432, 'name': '取消-经销商主动取消', 'code': '04', 'value': '取消-经销商主动取消', 'type': 35},
  {'id': 433, 'name': '取消-我司主动取消', 'code': '05', 'value': '取消-我司主动取消', 'type': 35},
  {'id': 434, 'name': '取消-其他', 'code': '06', 'value': '取消-其他', 'type': 35},
  {'id': 564, 'name': '商户备案信息', 'code': 'shba', 'value': '商户备案信息', 'type': 36},
  {'id': 565, 'name': '放款授权书', 'code': 'fksq', 'value': '放款授权书', 'type': 36},
  {'id': 566, 'name': '转账申请表', 'code': 'zzsq', 'value': '转账申请表', 'type': 36},
  {'id': 10009, 'name': '1档', 'code': 'gpsbase', 'value': '0', 'type': 37},
  {'id': 10114, 'name': '2档', 'code': 'gpsxzd', 'value': '1', 'type': 37},
  {'id': 10437, 'name': '3档', 'code': 'gpsxzdf', 'value': '2', 'type': 37},
  {'id': 10583, 'name': '车享包-1档', 'code': 'cxb-1d', 'value': '3', 'type': 37},
  {'id': 10584, 'name': '4档', 'code': 'gps4d', 'value': '4', 'type': 37},
  {'id': 10585, 'name': '车享包-2档', 'code': 'cxb-2d', 'value': '5', 'type': 37},
  {'id': 10031, 'name': '绿本快递单', 'code': 'lbkdd', 'value': '绿本快递单', 'type': 38},
  {'id': 10033, 'name': 'A1大型客车', 'code': 'A1', 'value': 'A1', 'type': 40},
  {'id': 10034, 'name': 'A2牵引车', 'code': 'A2', 'value': 'A2', 'type': 40},
  {'id': 10035, 'name': 'A3城市公交车', 'code': 'A3', 'value': 'A3', 'type': 40},
  {'id': 10036, 'name': 'B1中型客车', 'code': 'B1', 'value': 'B1', 'type': 40},
  {'id': 10037, 'name': 'B2大型货车', 'code': 'B2', 'value': 'B2', 'type': 40},
  {'id': 10038, 'name': 'C1小型汽车', 'code': 'C1', 'value': 'C1', 'type': 40},
  {'id': 10039, 'name': 'C2小型自动挡汽车', 'code': 'C2', 'value': 'C2', 'type': 40},
  {'id': 10040, 'name': 'C3低速载货汽车', 'code': 'C3', 'value': 'C3', 'type': 40},
  {'id': 10041, 'name': 'C4三轮汽车', 'code': 'C4', 'value': 'C4', 'type': 40},
  {'id': 10042, 'name': 'C5残疾人专供小型自动挡载客汽车', 'code': 'C5', 'value': 'C5', 'type': 40},
  {'id': 10043, 'name': 'D普通三轮摩托车', 'code': 'D', 'value': 'D', 'type': 40},
  {'id': 10044, 'name': 'E普通二轮摩托车', 'code': 'E', 'value': 'E', 'type': 40},
  {'id': 10045, 'name': 'F轻便摩托车', 'code': 'F', 'value': 'F', 'type': 40},
  {'id': 10046, 'name': 'M轮式自行机械车', 'code': 'M', 'value': 'M', 'type': 40},
  {'id': 10047, 'name': 'N无轨电车', 'code': 'N', 'value': 'N', 'type': 40},
  {'id': 10048, 'name': 'P有轨电车', 'code': 'P', 'value': 'P', 'type': 40},
  {'id': 10097, 'name': '信用卡', 'code': 'xyk', 'value': '0', 'type': 41},
  {'id': 10098, 'name': '借记卡', 'code': 'jjk', 'value': '1', 'type': 41},
  {'id': 10100, 'name': '1年', 'code': '1', 'value': '1', 'type': 42},
  {'id': 10101, 'name': '2年', 'code': '2', 'value': '2', 'type': 42},
  {'id': 10102, 'name': '3年', 'code': '3', 'value': '3', 'type': 42},
  {'id': 10103, 'name': '4年', 'code': '4', 'value': '4', 'type': 42},
  {'id': 10104, 'name': '5年', 'code': '5', 'value': '5', 'type': 42},
  {'id': 10105, 'name': '5年以上', 'code': '5+', 'value': '5y+', 'type': 42},
  {'id': 10107, 'name': '否', 'code': '', 'value': '0', 'type': 43},
  {'id': 10108, 'name': '简版征信', 'code': '1', 'value': '1', 'type': 43},
  {'id': 10109, 'name': '详版征信', 'code': '2', 'value': '2', 'type': 43},
  {'id': 10151, 'name': '铅笔头征信', 'code': '3', 'value': '3', 'type': 43},
  {'id': 10112, 'name': 'redbook', 'code': 'rb', 'value': 'redbook', 'type': 44},
  {'id': 10113, 'name': '车300', 'code': 'c300', 'value': '车300', 'type': 44},
  {'id': 10149, 'name': '带货安装', 'code': '', 'value': '1', 'type': 45},
  {'id': 10150, 'name': '自行安装', 'code': '1', 'value': '2', 'type': 45},
  {'id': 10136, 'name': '有线-赛格TRG80', 'code': 'sg', 'value': '有线-赛格-SEG9888-TRG80', 'type': 49},
  {'id': 10137, 'name': '无线-赛格TRG90', 'code': 'sg', 'value': '无线-赛格-SEG9888-TRG90', 'type': 49},
  {'id': 10154, 'name': '套餐A', 'code': 'cs', 'value': '1', 'type': 50},
  {'id': 10155, 'name': '套餐B', 'code': 'cs2', 'value': '2', 'type': 50},
  {'id': 10165, 'name': '浦发信用卡', 'code': 'code1', 'value': '0053001', 'type': 53},
  {'id': 10179, 'name': '南京', 'code': 'fh001', 'value': 'NJ', 'type': 54},
  {'id': 10184, 'name': '广州', 'code': 'fh001', 'value': 'GZ', 'type': 54},
  {'id': 10185, 'name': '深圳', 'code': 'fh001', 'value': 'SZ', 'type': 54},
  {'id': 10188, 'name': '武汉', 'code': 'fh001', 'value': 'WH', 'type': 54},
  {'id': 10189, 'name': '长沙', 'code': 'fh001', 'value': 'CS', 'type': 54},
  {'id': 10193, 'name': '西安', 'code': 'fh001', 'value': 'XA', 'type': 54},
  {'id': 10194, 'name': '成都', 'code': 'fh001', 'value': 'CD', 'type': 54},
  {'id': 10207, 'name': '贵阳', 'code': 'fh001', 'value': 'GY', 'type': 54},
  {'id': 10434, 'name': '佛山', 'code': 'fh001', 'value': 'FS', 'type': 54},
  {'id': 10435, 'name': '东莞', 'code': 'fh001', 'value': 'DG', 'type': 54},
  {'id': 10436, 'name': '中山', 'code': 'fh001', 'value': 'ZS', 'type': 54},
  {'id': 10569, 'name': '榆林', 'code': 'YL', 'value': 'YL', 'type': 54},
  {'id': 10570, 'name': '珠海', 'code': 'ZH', 'value': 'ZH', 'type': 54},
  {'id': 10571, 'name': '惠州', 'code': 'HU', 'value': 'HU', 'type': 54},
  {'id': 10160, 'name': '无需安装', 'code': 'NO', 'value': '0', 'type': 55},
  {'id': 10161, 'name': '无线X1', 'code': 'WX1', 'value': '1', 'type': 55},
  {'id': 10162, 'name': '无线X1,有线X1', 'code': 'WX1YX1', 'value': '2', 'type': 55},
  {'id': 10254, 'name': '华昌授权书', 'code': '2017030101', 'value': 'Y01', 'type': 56},
  {'id': 10255, 'name': '身份证复印件', 'code': '2017030102', 'value': 'Y02', 'type': 56},
  {'id': 10256, 'name': '借款服务合同', 'code': '2017030103', 'value': 'Y03', 'type': 56},
  {'id': 10257, 'name': '抵押合同', 'code': '2017030104', 'value': 'Y04', 'type': 56},
  {'id': 10259, 'name': '汽车融资租赁售后回租服务合同专用条件', 'code': '2017030106', 'value': 'Y06', 'type': 56},
  {'id': 10260, 'name': '汽车融资租赁售后回租合同专用条款', 'code': '2017030107', 'value': 'Y07', 'type': 56},
  {'id': 10261, 'name': '汽车抵押合同专用条款', 'code': '2017030108', 'value': 'Y08', 'type': 56},
  {'id': 10262, 'name': '扣款授权书', 'code': '2017030109', 'value': 'Y09', 'type': 56},
  {'id': 10263, 'name': '反欺诈风险提示函', 'code': '2017030110', 'value': 'Y10', 'type': 56},
  {'id': 10264, 'name': '登记证书', 'code': '2017030111', 'value': 'Y11', 'type': 56},
  {'id': 10265, 'name': '其他资料', 'code': '2017030112', 'value': 'Y12', 'type': 56},
  {'id': 10252, 'name': '身份证复印件', 'code': '2017030202', 'value': 'DB02', 'type': 57},
  {'id': 10246, 'name': '销售发票扫描件', 'code': 'scan_type1', 'value': '01', 'type': 58},
  {'id': 10247, 'name': '车辆保单扫描件', 'code': 'scan_type2', 'value': '02', 'type': 58},
  {'id': 10248, 'name': '登记证书扫描件', 'code': 'scan_type3', 'value': '03', 'type': 58},
  {'id': 10249, 'name': '营运证扫描件（黄牌车）', 'code': 'scan_type4', 'value': '04', 'type': 58},
  {'id': 10267, 'name': '初审', 'code': '1', 'value': '3', 'type': 59},
  {'id': 10268, 'name': '复审', 'code': '2', 'value': '12', 'type': 59},
  {'id': 10269, 'name': '贷前', 'code': '4', 'value': '5', 'type': 59},
  {'id': 10270, 'name': '贷后', 'code': '5', 'value': '6', 'type': 59},
  {'id': 10317, 'name': '好客户', 'code': 'GOOD', 'value': 'P', 'type': 60},
  {'id': 10318, 'name': '一般客户', 'code': 'NORMAL', 'value': 'A,H,J,L', 'type': 60},
  {'id': 10387, 'name': '本地城镇', 'code': 'bdcz', 'value': '1', 'type': 61},
  {'id': 10388, 'name': '本地农村', 'code': 'bdnc', 'value': '2', 'type': 61},
  {'id': 10389, 'name': '外地城镇', 'code': 'wdcz', 'value': '3', 'type': 61},
  {'id': 10390, 'name': '外地农村', 'code': 'wdnc', 'value': '4', 'type': 61},
  {'id': 10382, 'name': '个人担保', 'code': 'grdb', 'value': '1', 'type': 62},
  {'id': 10384, 'name': '否', 'code': 'wdcz', 'value': '0', 'type': 62},
  {'id': 10574, 'name': '0档', 'code': 'rsbx0档', 'value': '0', 'type': 63},
  {'id': 10575, 'name': '1档', 'code': 'rsbx1档', 'value': '1', 'type': 63},
  {'id': 10577, 'name': '续保押金0档', 'code': 'xbyj', 'value': '0', 'type': 64},
  {'id': 10058, 'name': '收入证明/收入情况说明', 'code': '21000001', 'value': '0', 'type': 297},
  {'id': 10059, 'name': '银行流水(第一页)', 'code': '21000002', 'value': '0', 'type': 297},
  {'id': 10060, 'name': '银行流水(第二页)', 'code': '21000003', 'value': '0', 'type': 297},
  {'id': 10061, 'name': '二手车车身照片', 'code': '21002001', 'value': '0', 'type': 301},
  {'id': 10062, 'name': '二手车登记证书', 'code': '21002002', 'value': '0', 'type': 301},
  {'id': 10021, 'name': '借款类合同', 'code': '20000001', 'value': '0', 'type': 315},
  {'id': 10063, 'name': '抵押合同', 'code': '20000002', 'value': '1', 'type': 315},
  {'id': 10064, 'name': '银行卡正面', 'code': '20000003', 'value': '1', 'type': 315},
  {'id': 10065, 'name': '银行卡反面', 'code': '20000004', 'value': '1', 'type': 315},
  {'id': 10066, 'name': '扣款授权书', 'code': '20000005', 'value': '1', 'type': 315},
  {'id': 10067, 'name': '主贷人身份证正面', 'code': '20000006', 'value': '1', 'type': 315},
  {'id': 10068, 'name': '主贷人身份证反面', 'code': '20000007', 'value': '1', 'type': 315},
  {'id': 10069, 'name': '配偶(如有)身份证正面', 'code': '20000008', 'value': '0', 'type': 315},
  {'id': 10070, 'name': '配偶(如有)身份证反面', 'code': '20000009', 'value': '0', 'type': 315},
  {'id': 10076, 'name': '担保人(如有)身份证正面', 'code': '20000010', 'value': '0', 'type': 315},
  {'id': 10077, 'name': '担保人(如有)身份证反面', 'code': '20000011', 'value': '0', 'type': 315},
  {'id': 10078, 'name': '面签照片', 'code': '20000012', 'value': '1', 'type': 315},
  {'id': 10079, 'name': '销售合同', 'code': '20000013', 'value': '1', 'type': 315},
  {'id': 10080, 'name': '反欺诈提示函', 'code': '20000014', 'value': '1', 'type': 315},
  {'id': 10081, 'name': '首付款收据(如有)', 'code': '20000015', 'value': '0', 'type': 315},
  {'id': 10082, 'name': '复审要求收取的其他资料', 'code': '20000016', 'value': '0', 'type': 315},
  {'id': 10083, 'name': '登记证书', 'code': '20001001', 'value': '0', 'type': 351},
  {'id': 10084, 'name': '商业险保单', 'code': '20001002', 'value': '1', 'type': 351},
  {'id': 10085, 'name': '商业险保单发票', 'code': '20001003', 'value': '1', 'type': 351},
  {'id': 10086, 'name': '购车发票(如有)', 'code': '20001004', 'value': '0', 'type': 351},
  {'id': 10017, 'name': '征信授权承诺书', 'code': '21001001', 'value': '0', 'type': 357},
  {'id': 10049, 'name': '征信授权书面签照片', 'code': '21001002', 'value': '0', 'type': 357},
  {'id': 10050, 'name': '主贷人身份证正面', 'code': '21001003', 'value': '1', 'type': 357},
  {'id': 10051, 'name': '主贷人身份证反面', 'code': '21001004', 'value': '1', 'type': 357},
  {'id': 10052, 'name': '配偶(如有)身份证正面', 'code': '21001005', 'value': '0', 'type': 357},
  {'id': 10053, 'name': '配偶(如有)身份证反面', 'code': '21001006', 'value': '0', 'type': 357},
  {'id': 10087, 'name': '担保人(如有)身份证正面', 'code': '21001007', 'value': '0', 'type': 357},
  {'id': 10089, 'name': '担保人(如有)身份证反面', 'code': '21001008', 'value': '0', 'type': 357},
  {'id': 10117, 'name': '借款服务合同(通用版-等额本息)', 'code': 'printpf_de', 'value': 'printpf_pt_dehk', 'type': 462},
  {'id': 467, 'name': '借款模板', 'code': 'jk', 'value': 'printdyht', 'type': 463},
  {'id': 468, 'name': '租赁模板', 'code': 'zl', 'value': 'printdyht2', 'type': 463},
  {'id': 10392, 'name': '借款模板(挂靠)', 'code': 'gkthree', 'value': 'printdyht_gk', 'type': 463},
  {'id': 481, 'name': '动力智选', 'code': 'ybftc1', 'value': '动力智选', 'type': 480},
  {'id': 482, 'name': '综合优选', 'code': 'ybftc2', 'value': '综合优选', 'type': 480},
  {'id': 483, 'name': '全面精选', 'code': 'ybftc3', 'value': '全面精选', 'type': 480},
  {'id': 547, 'name': '第二年保险', 'code': 'ybtc4', 'value': '第二年保险', 'type': 480},
  {'id': 10481, 'name': 'fl11.05', 'code': 'fl11.05', 'value': '11.05', 'type': 480},
  {'id': 10438, 'name': 'fl3.55', 'code': 'fl3.55', 'value': '3.55', 'type': 485},
  {'id': 10439, 'name': 'fl4.8', 'code': 'fl4.8', 'value': '4.8', 'type': 485},
  {'id': 10440, 'name': 'fl6.59', 'code': 'fl6.59', 'value': '6.59', 'type': 485},
  {'id': 10441, 'name': 'fl7.9', 'code': 'fl7.9', 'value': '7.9', 'type': 485},
  {'id': 10442, 'name': 'fl9.63', 'code': 'fl9.63', 'value': '9.63', 'type': 485},
  {'id': 10443, 'name': 'fl4.66', 'code': 'fl4.66', 'value': '4.66', 'type': 485},
  {'id': 10444, 'name': 'fl6.42', 'code': 'fl6.42', 'value': '6.42', 'type': 485},
  {'id': 10445, 'name': 'fl10.58', 'code': 'fl10.58', 'value': '10.58', 'type': 485},
  {'id': 10446, 'name': 'fl12.86', 'code': 'fl12.86', 'value': '12.86', 'type': 485},
  {'id': 10447, 'name': 'fl2.79', 'code': 'fl2.79', 'value': '2.79', 'type': 485},
  {'id': 10448, 'name': 'fl3.68', 'code': 'fl3.68', 'value': '3.68', 'type': 485},
  {'id': 10449, 'name': 'fl5.1', 'code': 'fl5.1', 'value': '5.1', 'type': 485},
  {'id': 10450, 'name': 'fl6.04', 'code': 'fl6.04', 'value': '6.04', 'type': 485},
  {'id': 10451, 'name': 'fl7.39', 'code': 'fl7.39', 'value': '7.39', 'type': 485},
  {'id': 10452, 'name': 'fl6.54', 'code': 'fl6.54', 'value': '6.54', 'type': 485},
  {'id': 10453, 'name': 'fl7.43', 'code': 'fl7.43', 'value': '7.43', 'type': 485},
  {'id': 10454, 'name': 'fl8.85', 'code': 'fl8.85', 'value': '8.85', 'type': 485},
  {'id': 10455, 'name': 'fl9.79', 'code': 'fl9.79', 'value': '9.79', 'type': 485},
  {'id': 10456, 'name': 'fl11.14', 'code': 'fl11.14', 'value': '11.14', 'type': 485},
  {'id': 10457, 'name': 'fl10.29', 'code': 'fl10.29', 'value': '10.29', 'type': 485},
  {'id': 10458, 'name': 'fl11.18', 'code': 'fl11.18', 'value': '11.18', 'type': 485},
  {'id': 10459, 'name': 'fl12.6', 'code': 'fl12.6', 'value': '12.6', 'type': 485},
  {'id': 10460, 'name': 'fl13.54', 'code': 'fl13.54', 'value': '13.54', 'type': 485},
  {'id': 10461, 'name': 'fl14.89', 'code': 'fl14.89', 'value': '14.89', 'type': 485},
  {'id': 10462, 'name': 'fl5.29', 'code': 'fl5.29', 'value': '5.29', 'type': 485},
  {'id': 10463, 'name': 'fl6.18', 'code': 'fl6.18', 'value': '6.18', 'type': 485},
  {'id': 10464, 'name': 'fl7.6', 'code': 'fl7.6', 'value': '7.6', 'type': 485},
  {'id': 10465, 'name': 'fl8.54', 'code': 'fl8.54', 'value': '8.54', 'type': 485},
  {'id': 10466, 'name': 'fl9.89', 'code': 'fl9.89', 'value': '9.89', 'type': 485},
  {'id': 10467, 'name': 'fl9.04', 'code': 'fl9.04', 'value': '9.04', 'type': 485},
  {'id': 10468, 'name': 'fl9.93', 'code': 'fl9.93', 'value': '9.93', 'type': 485},
  {'id': 10469, 'name': 'fl11.35', 'code': 'fl11.35', 'value': '11.35', 'type': 485},
  {'id': 10470, 'name': 'fl12.29', 'code': 'fl12.29', 'value': '12.29', 'type': 485},
  {'id': 10471, 'name': 'fl13.64', 'code': 'fl13.64', 'value': '13.64', 'type': 485},
  {'id': 10472, 'name': 'fl6.05', 'code': 'fl6.05', 'value': '6.05', 'type': 485},
  {'id': 10473, 'name': 'fl7.3', 'code': 'fl7.3', 'value': '7.3', 'type': 485},
  {'id': 10474, 'name': 'fl9.09', 'code': 'fl9.09', 'value': '9.09', 'type': 485},
  {'id': 10475, 'name': 'fl12.13', 'code': 'fl12.13', 'value': '12.13', 'type': 485},
  {'id': 10476, 'name': 'fl8.55', 'code': 'fl8.55', 'value': '8.55', 'type': 485},
  {'id': 10477, 'name': 'fl10.34', 'code': 'fl10.34', 'value': '10.34', 'type': 485},
  {'id': 10478, 'name': 'fl11.65', 'code': 'fl11.65', 'value': '11.65', 'type': 485},
  {'id': 10479, 'name': 'fl13.38', 'code': 'fl13.38', 'value': '13.38', 'type': 485},
  {'id': 10480, 'name': 'fl9.8', 'code': 'fl9.8', 'value': '9.8', 'type': 485},
  {'id': 10482, 'name': 'fl12.84', 'code': 'fl12.84', 'value': '12.84', 'type': 485},
  {'id': 10483, 'name': 'fl14.15', 'code': 'fl14.15', 'value': '14.15', 'type': 485},
  {'id': 10484, 'name': 'fl15.88', 'code': 'fl15.88', 'value': '15.88', 'type': 485},
  {'id': 10485, 'name': 'fl12.3', 'code': 'fl12.3', 'value': '12.3', 'type': 485},
  {'id': 10486, 'name': 'fl14.09', 'code': 'fl14.09', 'value': '14.09', 'type': 485},
  {'id': 10487, 'name': 'fl15.4', 'code': 'fl15.4', 'value': '15.4', 'type': 485},
  {'id': 10488, 'name': 'fl17.13', 'code': 'fl17.13', 'value': '17.13', 'type': 485},
  {'id': 10489, 'name': 'fl11.05', 'code': 'fl11.05', 'value': '11.05', 'type': 485},
  {'id': 10490, 'name': 'fl8.41', 'code': 'fl8.41', 'value': '8.41', 'type': 485},
  {'id': 10491, 'name': 'fl10.17', 'code': 'fl10.17', 'value': '10.17', 'type': 485},
  {'id': 10492, 'name': 'fl14.33', 'code': 'fl14.33', 'value': '14.33', 'type': 485},
  {'id': 10493, 'name': 'fl16.61', 'code': 'fl16.61', 'value': '16.61', 'type': 485},
  {'id': 10494, 'name': 'fl10.91', 'code': 'fl10.91', 'value': '10.91', 'type': 485},
  {'id': 10495, 'name': 'fl12.67', 'code': 'fl12.67', 'value': '12.67', 'type': 485},
  {'id': 10496, 'name': 'fl16.83', 'code': 'fl16.83', 'value': '16.83', 'type': 485},
  {'id': 10497, 'name': 'fl19.11', 'code': 'fl19.11', 'value': '19.11', 'type': 485},
  {'id': 10498, 'name': 'fl5.82', 'code': 'fl5.82', 'value': '5.82', 'type': 485},
  {'id': 10499, 'name': 'fl8.14', 'code': 'fl8.14', 'value': '8.14', 'type': 485},
  {'id': 10500, 'name': 'fl11.03', 'code': 'fl11.03', 'value': '11.03', 'type': 485},
  {'id': 10501, 'name': 'fl16.32', 'code': 'fl16.32', 'value': '16.32', 'type': 485},
  {'id': 10502, 'name': 'fl10.64', 'code': 'fl10.64', 'value': '10.64', 'type': 485},
  {'id': 10503, 'name': 'fl8.32', 'code': 'fl8.32', 'value': '8.32', 'type': 485},
  {'id': 10504, 'name': 'fl13.53', 'code': 'fl13.53', 'value': '13.53', 'type': 485},
  {'id': 10505, 'name': 'fl15.95', 'code': 'fl15.95', 'value': '15.95', 'type': 485},
  {'id': 10506, 'name': 'fl18.82', 'code': 'fl18.82', 'value': '18.82', 'type': 485},
  {'id': 10507, 'name': 'fl9.57', 'code': 'fl9.57', 'value': '9.57', 'type': 485},
  {'id': 10508, 'name': 'fl11.89', 'code': 'fl11.89', 'value': '11.89', 'type': 485},
  {'id': 10509, 'name': 'fl14.78', 'code': 'fl14.78', 'value': '14.78', 'type': 485},
  {'id': 10510, 'name': 'fl17.2', 'code': 'fl17.2', 'value': '17.2', 'type': 485},
  {'id': 10511, 'name': 'fl20.07', 'code': 'fl20.07', 'value': '20.07', 'type': 485},
  {'id': 10512, 'name': 'fl12.07', 'code': 'fl12.07', 'value': '12.07', 'type': 485},
  {'id': 10513, 'name': 'fl14.39', 'code': 'fl14.39', 'value': '14.39', 'type': 485},
  {'id': 10514, 'name': 'fl17.28', 'code': 'fl17.28', 'value': '17.28', 'type': 485},
  {'id': 10515, 'name': 'fl19.7', 'code': 'fl19.7', 'value': '19.7', 'type': 485},
  {'id': 10516, 'name': 'fl22.57', 'code': 'fl22.57', 'value': '22.57', 'type': 485},
  {'id': 10517, 'name': 'fl13.32', 'code': 'fl13.32', 'value': '13.32', 'type': 485},
  {'id': 10518, 'name': 'fl15.64', 'code': 'fl15.64', 'value': '15.64', 'type': 485},
  {'id': 10519, 'name': 'fl18.53', 'code': 'fl18.53', 'value': '18.53', 'type': 485},
  {'id': 10520, 'name': 'fl20.95', 'code': 'fl20.95', 'value': '20.95', 'type': 485},
  {'id': 10521, 'name': 'fl23.82', 'code': 'fl23.82', 'value': '23.82', 'type': 485},
  {'id': 10522, 'name': 'fl7.79', 'code': 'fl7.79', 'value': '7.79', 'type': 485},
  {'id': 10523, 'name': 'fl8.68', 'code': 'fl8.68', 'value': '8.68', 'type': 485},
  {'id': 10524, 'name': 'fl10.1', 'code': 'fl10.1', 'value': '10.1', 'type': 485},
  {'id': 10525, 'name': 'fl11.04', 'code': 'fl11.04', 'value': '11.04', 'type': 485},
  {'id': 10526, 'name': 'fl12.39', 'code': 'fl12.39', 'value': '12.39', 'type': 485},
  {'id': 10527, 'name': 'fl11.54', 'code': 'fl11.54', 'value': '11.54', 'type': 485},
  {'id': 10528, 'name': 'fl12.43', 'code': 'fl12.43', 'value': '12.43', 'type': 485},
  {'id': 10529, 'name': 'fl13.85', 'code': 'fl13.85', 'value': '13.85', 'type': 485},
  {'id': 10530, 'name': 'fl14.79', 'code': 'fl14.79', 'value': '14.79', 'type': 485},
  {'id': 10531, 'name': 'fl16.14', 'code': 'fl16.14', 'value': '16.14', 'type': 485},
  {'id': 10532, 'name': 'fl12.79', 'code': 'fl12.79', 'value': '12.79', 'type': 485},
  {'id': 10533, 'name': 'fl13.68', 'code': 'fl13.68', 'value': '13.68', 'type': 485},
  {'id': 10534, 'name': 'fl15.1', 'code': 'fl15.1', 'value': '15.1', 'type': 485},
  {'id': 10535, 'name': 'fl16.04', 'code': 'fl16.04', 'value': '16.04', 'type': 485},
  {'id': 10536, 'name': 'fl17.39', 'code': 'fl17.39', 'value': '17.39', 'type': 485},
  {'id': 10537, 'name': 'fl11.59', 'code': 'fl11.59', 'value': '11.59', 'type': 485},
  {'id': 10538, 'name': 'fl12.9', 'code': 'fl12.9', 'value': '12.9', 'type': 485},
  {'id': 10539, 'name': 'fl14.63', 'code': 'fl14.63', 'value': '14.63', 'type': 485},
  {'id': 10540, 'name': 'fl13.55', 'code': 'fl13.55', 'value': '13.55', 'type': 485},
  {'id': 10541, 'name': 'fl15.34', 'code': 'fl15.34', 'value': '15.34', 'type': 485},
  {'id': 10542, 'name': 'fl18.38', 'code': 'fl18.38', 'value': '18.38', 'type': 485},
  {'id': 10543, 'name': 'fl14.8', 'code': 'fl14.8', 'value': '14.8', 'type': 485},
  {'id': 10544, 'name': 'fl16.59', 'code': 'fl16.59', 'value': '16.59', 'type': 485},
  {'id': 10545, 'name': 'fl17.9', 'code': 'fl17.9', 'value': '17.9', 'type': 485},
  {'id': 10546, 'name': 'fl19.63', 'code': 'fl19.63', 'value': '19.63', 'type': 485},
  {'id': 10547, 'name': 'fl13.41', 'code': 'fl13.41', 'value': '13.41', 'type': 485},
  {'id': 10548, 'name': 'fl15.17', 'code': 'fl15.17', 'value': '15.17', 'type': 485},
  {'id': 10549, 'name': 'fl19.33', 'code': 'fl19.33', 'value': '19.33', 'type': 485},
  {'id': 10550, 'name': 'fl21.61', 'code': 'fl21.61', 'value': '21.61', 'type': 485},
  {'id': 10551, 'name': 'fl10.82', 'code': 'fl10.82', 'value': '10.82', 'type': 485},
  {'id': 10552, 'name': 'fl13.14', 'code': 'fl13.14', 'value': '13.14', 'type': 485},
  {'id': 10553, 'name': 'fl16.03', 'code': 'fl16.03', 'value': '16.03', 'type': 485},
  {'id': 10554, 'name': 'fl18.45', 'code': 'fl18.45', 'value': '18.45', 'type': 485},
  {'id': 10555, 'name': 'fl21.32', 'code': 'fl21.32', 'value': '21.32', 'type': 485},
  {'id': 10556, 'name': 'fl14.57', 'code': 'fl14.57', 'value': '14.57', 'type': 485},
  {'id': 10557, 'name': 'fl16.89', 'code': 'fl16.89', 'value': '16.89', 'type': 485},
  {'id': 10558, 'name': 'fl19.78', 'code': 'fl19.78', 'value': '19.78', 'type': 485},
  {'id': 10559, 'name': 'fl22.2', 'code': 'fl22.2', 'value': '22.2', 'type': 485},
  {'id': 10560, 'name': 'fl25.07', 'code': 'fl25.07', 'value': '25.07', 'type': 485},
  {'id': 10561, 'name': 'fl15.82', 'code': 'fl15.82', 'value': '15.82', 'type': 485},
  {'id': 10562, 'name': 'fl18.14', 'code': 'fl18.14', 'value': '18.14', 'type': 485},
  {'id': 10563, 'name': 'fl21.03', 'code': 'fl21.03', 'value': '21.03', 'type': 485},
  {'id': 10564, 'name': 'fl23.45', 'code': 'fl23.45', 'value': '23.45', 'type': 485},
  {'id': 10565, 'name': 'fl26.32', 'code': 'fl26.32', 'value': '26.32', 'type': 485},
  {'id': 10578, 'name': 'fl15.29', 'code': 'fl15.29', 'value': '15.29', 'type': 485},
  {'id': 10579, 'name': 'fl16.18', 'code': 'fl16.18', 'value': '16.18', 'type': 485},
  {'id': 10580, 'name': 'fl17.6', 'code': 'fl17.6', 'value': '17.6', 'type': 485},
  {'id': 10581, 'name': 'fl18.54', 'code': 'fl18.54', 'value': '18.54', 'type': 485},
  {'id': 10582, 'name': 'fl19.89', 'code': 'fl19.89', 'value': '19.89', 'type': 485},
  {'id': 486, 'name': '费率0', 'code': 'rxsfl0', 'value': '0', 'type': 485},
  {'id': 487, 'name': '费率1', 'code': 'rxsfl1', 'value': '1', 'type': 485},
  {'id': 491, 'name': '费率2', 'code': 'rxsfl2', 'value': '2', 'type': 485},
  {'id': 494, 'name': '费率3', 'code': 'rxsfl3', 'value': '3', 'type': 485},
  {'id': 495, 'name': '费率4', 'code': 'rxsfl4', 'value': '4', 'type': 485},
  {'id': 496, 'name': '费率5', 'code': 'rxsfl5', 'value': '5', 'type': 485},
  {'id': 527, 'name': '费率1.5', 'code': 'fl', 'value': '1.5', 'type': 485},
  {'id': 529, 'name': '费率6', 'code': 'rxsfl6', 'value': '6', 'type': 485},
  {'id': 530, 'name': '费率9', 'code': 'rxsfl9', 'value': '9', 'type': 485},
  {'id': 10001, 'name': '费率4.2', 'code': 'fl4.2', 'value': '4.2', 'type': 485},
  {'id': 10002, 'name': '费率5.5', 'code': 'fl5.5', 'value': '5.5', 'type': 485},
  {'id': 10003, 'name': '费率6.7', 'code': 'fl6.7', 'value': '6.7', 'type': 485},
  {'id': 10004, 'name': '费率8', 'code': 'fl8', 'value': '8', 'type': 485},
  {'id': 10005, 'name': '费率10', 'code': 'fl10', 'value': '10', 'type': 485},
  {'id': 10006, 'name': '费率15', 'code': 'fl15', 'value': '15', 'type': 485},
  {'id': 10071, 'name': '费率6.75', 'code': 'f675', 'value': '6.75', 'type': 485},
  {'id': 10072, 'name': 'fl7.95', 'code': 'fl795', 'value': '7.95', 'type': 485},
  {'id': 10073, 'name': 'fl9.25', 'code': 'fl9.25', 'value': '9.25', 'type': 485},
  {'id': 10074, 'name': 'fl10.45', 'code': 'fl1045', 'value': '10.45', 'type': 485},
  {'id': 10075, 'name': 'fl11.75', 'code': 'fl1175', 'value': '11.75', 'type': 485},
  {'id': 10091, 'name': 'fl7', 'code': 'fl77', 'value': '7', 'type': 485},
  {'id': 10092, 'name': 'fl12', 'code': 'fl12', 'value': '12', 'type': 485},
  {'id': 10110, 'name': 'fl17', 'code': 'fl17', 'value': '17', 'type': 485},
  {'id': 10118, 'name': 'fl9.2', 'code': 'fl9.2', 'value': '9.2', 'type': 485},
  {'id': 10119, 'name': 'fl10.5', 'code': 'fl10.5', 'value': '10.5', 'type': 485},
  {'id': 10120, 'name': 'fl11.7', 'code': 'fl11.7', 'value': '11.7', 'type': 485},
  {'id': 10121, 'name': 'fl13', 'code': 'fl13', 'value': '13', 'type': 485},
  {'id': 10122, 'name': 'fl14', 'code': 'fl14', 'value': '14', 'type': 485},
  {'id': 10123, 'name': 'fl11.5', 'code': 'fl11.5', 'value': '11.5', 'type': 485},
  {'id': 10124, 'name': 'fl8.5', 'code': 'fl8.5', 'value': '8.5', 'type': 485},
  {'id': 10126, 'name': 'fl7.5', 'code': 'fl7.5', 'value': '7.5', 'type': 485},
  {'id': 10127, 'name': 'fl12.5', 'code': 'fl12.5', 'value': '12.5', 'type': 485},
  {'id': 10128, 'name': 'fl18', 'code': 'fl18', 'value': '18', 'type': 485},
  {'id': 10129, 'name': 'fl6.5', 'code': 'fl6.5', 'value': '6.5', 'type': 485},
  {'id': 10131, 'name': 'fl14.9', 'code': 'fl14.9', 'value': '14.9', 'type': 485},
  {'id': 10138, 'name': 'fl14.5', 'code': 'fl14.5', 'value': '14.5', 'type': 485},
  {'id': 10139, 'name': 'fl11', 'code': 'fl11', 'value': '11', 'type': 485},
  {'id': 10140, 'name': 'fl15.5', 'code': 'fl15.5', 'value': '15.5', 'type': 485},
  {'id': 10142, 'name': 'fl13.5', 'code': 'fl13.5', 'value': '13.5', 'type': 485},
  {'id': 10143, 'name': 'fl16.5', 'code': 'fl16.5', 'value': '16.5', 'type': 485},
  {'id': 10144, 'name': 'fl19.5', 'code': 'fl19.5', 'value': '19.5', 'type': 485},
  {'id': 10145, 'name': 'fl9.5', 'code': 'fl9.5', 'value': '9.5', 'type': 485},
  {'id': 10147, 'name': 'fl16', 'code': 'fl16', 'value': '16', 'type': 485},
  {'id': 10156, 'name': 'fl3.5', 'code': 'fl3.5', 'value': '3.5', 'type': 485},
  {'id': 10158, 'name': 'fl4.5', 'code': 'fl4.5', 'value': '4.5', 'type': 485},
  {'id': 10221, 'name': 'fl8.2', 'code': 'fl8.2', 'value': '8.2', 'type': 485},
  {'id': 10222, 'name': 'fl10.7', 'code': 'fl10.7', 'value': '10.7', 'type': 485},
  {'id': 10225, 'name': 'fl4.25', 'code': 'fl4.25', 'value': '4.25', 'type': 485},
  {'id': 10226, 'name': 'fl4.25', 'code': 'fl7.2', 'value': '7.2', 'type': 485},
  {'id': 10227, 'name': 'fl8.4', 'code': 'fl8.4', 'value': '8.4', 'type': 485},
  {'id': 10228, 'name': 'fl9.7', 'code': 'fl9.7', 'value': '9.7', 'type': 485},
  {'id': 10229, 'name': 'fl10.9', 'code': 'fl10.9', 'value': '10.9', 'type': 485},
  {'id': 10230, 'name': 'fl12.2', 'code': 'fl12.2', 'value': '12.2', 'type': 485},
  {'id': 10231, 'name': 'fl14.2', 'code': 'fl14.2', 'value': '14.2', 'type': 485},
  {'id': 10232, 'name': 'fl9.75', 'code': 'fl9.75', 'value': '9.75', 'type': 485},
  {'id': 10233, 'name': 'fl12.75', 'code': 'fl12.75', 'value': '12.75', 'type': 485},
  {'id': 10235, 'name': 'fl10.25', 'code': 'fl10.25', 'value': '10.25', 'type': 485},
  {'id': 10236, 'name': 'fl13.75', 'code': 'fl13.75', 'value': '13.75', 'type': 485},
  {'id': 10237, 'name': 'fl11.25', 'code': 'fl11.25', 'value': '11.25', 'type': 485},
  {'id': 10238, 'name': 'fl16.75', 'code': 'fl16.75', 'value': '16.75', 'type': 485},
  {'id': 10239, 'name': 'fl14.25', 'code': 'fl14.25', 'value': '14.25', 'type': 485},
  {'id': 10240, 'name': 'fl13.25', 'code': 'fl13.25', 'value': '13.25', 'type': 485},
  {'id': 10241, 'name': 'fl7.75', 'code': 'fl7.75', 'value': '7.75', 'type': 485},
  {'id': 10242, 'name': 'fl8.75', 'code': 'fl8.75', 'value': '8.75', 'type': 485},
  {'id': 10243, 'name': 'fl7.25', 'code': 'fl7.25', 'value': '7.25', 'type': 485},
  {'id': 10271, 'name': '12.95', 'code': 'fl12.95', 'value': '12.95', 'type': 485},
  {'id': 10272, 'name': '11.95', 'code': 'fl11.95', 'value': '11.95', 'type': 485},
  {'id': 10273, 'name': '10.75', 'code': 'fl10.75', 'value': '10.75', 'type': 485},
  {'id': 10274, 'name': '9.45', 'code': 'fl9.45', 'value': '9.45', 'type': 485},
  {'id': 10275, 'name': '8.25', 'code': 'fl8.25', 'value': '8.25', 'type': 485},
  {'id': 10276, 'name': 'fl8.7', 'code': 'fl8.7', 'value': '8.7', 'type': 485},
  {'id': 10278, 'name': 'fl11.2', 'code': 'fl11.2', 'value': '11.2', 'type': 485},
  {'id': 10294, 'name': 'fl12.25', 'code': 'fl12.25', 'value': '12.25', 'type': 485},
  {'id': 10298, 'name': 'fl16.25', 'code': 'fl16.25', 'value': '16.25', 'type': 485},
  {'id': 10299, 'name': 'fl18.25', 'code': 'fl18.25', 'value': '18.25', 'type': 485},
  {'id': 10300, 'name': 'fl18.75', 'code': 'fl18.75', 'value': '18.75', 'type': 485},
  {'id': 10301, 'name': 'fl21.25', 'code': 'fl21.25', 'value': '21.25', 'type': 485},
  {'id': 10302, 'name': 'fl5.86', 'code': 'fl5.86', 'value': '5.86', 'type': 485},
  {'id': 10303, 'name': 'fl11.67', 'code': 'fl11.67', 'value': '11.67', 'type': 485},
  {'id': 10304, 'name': 'fl16.98', 'code': 'fl16.98', 'value': '16.98', 'type': 485},
  {'id': 10306, 'name': 'fl9.76', 'code': '费率9.76', 'value': '9.76', 'type': 485},
  {'id': 10308, 'name': 'fl8.99', 'code': '费率8.99', 'value': '8.99', 'type': 485},
  {'id': 10309, 'name': 'fl7.72', 'code': '费率7.72', 'value': '7.72', 'type': 485},
  {'id': 10310, 'name': 'fl6.22', 'code': 'fl6.22', 'value': '6.22', 'type': 485},
  {'id': 10311, 'name': 'fl13.21', 'code': 'fl13.21', 'value': '13.21', 'type': 485},
  {'id': 10312, 'name': 'fl20.45', 'code': 'fl20.45', 'value': '20.45', 'type': 485},
  {'id': 10313, 'name': 'fl5.75', 'code': '费率5.75', 'value': '5.75', 'type': 485},
  {'id': 10320, 'name': 'fl2.5', 'code': '费率2.5', 'value': '2.5', 'type': 485},
  {'id': 10321, 'name': 'fl3.8', 'code': '费率3.8', 'value': '3.8', 'type': 485},
  {'id': 10322, 'name': 'fl6.25', 'code': '费率6.25', 'value': '6.25', 'type': 485},
  {'id': 10323, 'name': 'fl6.3', 'code': '费率6.3', 'value': '6.3', 'type': 485},
  {'id': 10324, 'name': 'fl7.55', 'code': '费率7.55', 'value': '7.55', 'type': 485},
  {'id': 10325, 'name': 'fl8.8', 'code': '费率8.8', 'value': '8.8', 'type': 485},
  {'id': 10326, 'name': 'fl11.3', 'code': '费率11.3', 'value': '11.3', 'type': 485},
  {'id': 10327, 'name': 'fl13.2', 'code': '费率13.2', 'value': '13.2', 'type': 485},
  {'id': 10328, 'name': 'fl5.9', 'code': 'fl5.9', 'value': '5.9', 'type': 485},
  {'id': 10329, 'name': 'fl18.5', 'code': 'fl18.5', 'value': '18.5', 'type': 485},
  {'id': 10330, 'name': 'fl21', 'code': 'fl21', 'value': '21', 'type': 485},
  {'id': 10332, 'name': 'fl9.85', 'code': 'fl9.85', 'value': '9.85', 'type': 485},
  {'id': 10333, 'name': 'fl3.6', 'code': 'fl3.6', 'value': '3.6', 'type': 485},
  {'id': 10334, 'name': 'fl10.4', 'code': 'fl10.4', 'value': '10.4', 'type': 485},
  {'id': 10335, 'name': 'fl6.6', 'code': 'fl6.6', 'value': '6.6', 'type': 485},
  {'id': 10336, 'name': 'fl12.45', 'code': 'fl12.45', 'value': '12.45', 'type': 485},
  {'id': 10337, 'name': 'fl14.4', 'code': 'fl14.4', 'value': '14.4', 'type': 485},
  {'id': 10338, 'name': 'fl13.45', 'code': 'fl13.45', 'value': '13.45', 'type': 485},
  {'id': 10339, 'name': 'fl14.95', 'code': 'fl14.95', 'value': '14.95', 'type': 485},
  {'id': 10340, 'name': 'fl16.65', 'code': 'fl16.65', 'value': '16.65', 'type': 485},
  {'id': 10341, 'name': 'fl17.5', 'code': 'fl17.5', 'value': '17.5', 'type': 485},
  {'id': 10342, 'name': '21.5', 'code': 'fl21.5', 'value': '21.5', 'type': 485},
  {'id': 10343, 'name': 'fl23.5', 'code': 'fl23.5', 'value': '23.5', 'type': 485},
  {'id': 10351, 'name': 'f6.2', 'code': 'f6.2', 'value': '6.2', 'type': 485},
  {'id': 10352, 'name': 'f10.2', 'code': 'f10.2', 'value': '10.2', 'type': 485},
  {'id': 10353, 'name': 'fl19', 'code': 'fl19', 'value': '19', 'type': 485},
  {'id': 10354, 'name': 'fl5.7', 'code': 'fl5.7', 'value': '5.7', 'type': 485},
  {'id': 10355, 'name': 'fl6.07', 'code': 'fl6.07', 'value': '6.07', 'type': 485},
  {'id': 10356, 'name': 'fl12.36', 'code': 'fl12.36', 'value': '12.36', 'type': 485},
  {'id': 10357, 'name': 'fl18.34', 'code': 'fl18.34', 'value': '18.34', 'type': 485},
  {'id': 10359, 'name': 'fl7.57', 'code': 'fl7.57', 'value': '7.57', 'type': 485},
  {'id': 10360, 'name': 'fl14.98', 'code': 'fl14.98', 'value': '14.98', 'type': 485},
  {'id': 10361, 'name': 'fl23.46', 'code': 'fl23.46', 'value': '23.46', 'type': 485},
  {'id': 10368, 'name': 'f13.4', 'code': 'f13.4', 'value': '13.4', 'type': 485},
  {'id': 10369, 'name': 'f15.7', 'code': 'f15.7', 'value': '15.7', 'type': 485},
  {'id': 10370, 'name': 'f24', 'code': 'f24', 'value': '24', 'type': 485},
  {'id': 10371, 'name': 'f12.15', 'code': 'f12.15', 'value': '12.15', 'type': 485},
  {'id': 10373, 'name': 'f14.45', 'code': 'f14.45', 'value': '14.45', 'type': 485},
  {'id': 10374, 'name': 'f17.25', 'code': 'f17.25', 'value': '17.25', 'type': 485},
  {'id': 10375, 'name': 'f19.75', 'code': 'f19.75', 'value': '19.75', 'type': 485},
  {'id': 10376, 'name': 'f22.75', 'code': 'f22.75', 'value': '22.75', 'type': 485},
  {'id': 10377, 'name': 'fl9.65', 'code': 'fl9.65', 'value': '9.65', 'type': 485},
  {'id': 10378, 'name': 'fl14.75', 'code': 'fl14.75', 'value': '14.75', 'type': 485},
  {'id': 10379, 'name': 'fl20.25', 'code': 'fl20.25', 'value': '20.25', 'type': 485},
  {'id': 10380, 'name': 'fl10.05', 'code': 'fl10.05', 'value': '10.05', 'type': 485},
  {'id': 10385, 'name': 'fl15.25', 'code': 'fl15.25', 'value': '15.25', 'type': 485},
  {'id': 10400, 'name': 'FL15.9', 'code': 'FL15.9', 'value': '15.9', 'type': 485},
  {'id': 10401, 'name': 'FL18.2', 'code': 'FL18.2', 'value': '18.2', 'type': 485},
  {'id': 10402, 'name': 'FL26.5', 'code': 'FL26.5', 'value': '26.5', 'type': 485},
  {'id': 560, 'name': '仅有纸质还款授权书', 'code': 'zzsqs', 'value': '3', 'type': 499},
  {'id': 10432, 'name': '汽车抵押合同-通用版', 'code': '10', 'value': '汽车抵押合同-通用版', 'type': 503},
  {'id': 517, 'name': '贷后资料遗失-扫描件', 'code': 'dhzlyssmj', 'value': '贷后资料遗失-扫描件', 'type': 516},
  {'id': 518, 'name': '贷后资料疑似造假-扫描件', 'code': 'dhzlyszj', 'value': '贷后资料疑似造假-扫描件', 'type': 516},
  {'id': 519, 'name': '销售发票高低开-扫描件', 'code': 'xsfpgdk', 'value': '销售发票高低开-扫描件', 'type': 516},
  {'id': 520, 'name': '抵押错误-登记证书', 'code': 'dycwdjzs', 'value': '抵押错误-登记证书', 'type': 516},
  {'id': 521, 'name': '无法办理抵押-登记证书', 'code': 'wfbldydjzs', 'value': '无法办理抵押-登记证书', 'type': 516},
  {'id': 523, 'name': '邮寄在途-登记证书', 'code': 'yjztdjzs', 'value': '邮寄在途-登记证书', 'type': 516},
  {'id': 524, 'name': '无法备案-登记证书', 'code': 'wfbadjzs', 'value': '无法备案-登记证书', 'type': 516},
  {'id': 525, 'name': '其他-登记证书,扫描件', 'code': 'qt', 'value': '其他-登记证书,扫描件', 'type': 516},
  {'id': 526, 'name': '登记证书遗失-登记证书', 'code': 'djzsysdjzs', 'value': '登记证书遗失-登记证书', 'type': 516},
  {'id': 10056, 'name': '驾驶证正面', 'code': '21003001', 'value': '1', 'type': 10054},
  {'id': 10057, 'name': '驾驶证反面', 'code': '21003002', 'value': '1', 'type': 10054}]
export default param



// WEBPACK FOOTER //
// ./src/assets/js/param.js